import React from 'react'
import Dashboard from './Pages/Dashboard'

const App = () => {
  return (
    <div><Dashboard /></div>
  )
}

export default App